var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-checkbox",
        {
          on: { change: _vm.emitChangeEvent },
          model: {
            value: _vm.none,
            callback: function($$v) {
              _vm.none = $$v
            },
            expression: "none"
          }
        },
        [
          _vm._v(
            "\n\t\tEs ist keine bestimmte Staatsbürgerschaft erforderlich\n\t"
          )
        ]
      ),
      _vm._v(" "),
      !_vm.none
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("CountryAutocomplete", {
                attrs: { meta: _vm.meta },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.items,
                  callback: function($$v) {
                    _vm.items = $$v
                  },
                  expression: "items"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }